import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import type { StructuredSearchFields } from '@core/Areas/StructuredSearch/types'
import { RangeBoundaries } from '../constants'

export interface StructuredSearchState {
  searchCriteria: StructuredSearchFields
}

const initialSearchCriteria: StructuredSearchFields = {
  contestTypeRace: false,
  contestTypeTrot: false,
  contestTypeDogs: false,
  dateToday: false,
  dateTomorrow: false,
  dateBeyondTomorrow: false,
  wonLastStart: false,
  placedLastStart: false,
  gearChange: false,
  firstUp: false,
  secondUp: false,
  careerPrizeMoney: '',
  careerWinPercentage: RangeBoundaries.minPercentage,
  trackWinPercentage: RangeBoundaries.minPercentage,
  distanceWinPercentage: RangeBoundaries.minPercentage,
  trackdistanceWinPercentage: RangeBoundaries.minPercentage,
  barrierNumberOneToFive: false,
  barrierNumberSixPlus: false,
  boxNumberOneToFour: false,
  boxNumberFivePlus: false,
  apprentice: false,
  favouriteLastStart: false,
  weightChangedUp: false,
  weightChangedDown: false,
  weightNotChanged: false,
  distanceChangedUp: false,
  distanceChangedDown: false,
  distanceNotChanged: false,
  winTrackConditionFirm: false,
  winTrackConditionGood: false,
  winTrackConditionHeavy: false,
  winTrackConditionSoft: false,
  winTrackConditionSynthetic: false,
  locationCountryAustralia: false,
  locationCountryNewZealand: false,
  locationCountryInternational: false,
  selectedTracks: [],
  ...RangeBoundaries,
}

export const initialState: StructuredSearchState = {
  searchCriteria: initialSearchCriteria,
}

const structuredSearchSlice = createSlice({
  name: 'structuredSearch',
  initialState,
  reducers: {
    setSearchField<K extends keyof StructuredSearchFields>(
      state: StructuredSearchState,
      action: PayloadAction<{ field: K; value: StructuredSearchFields[K] }>
    ) {
      state.searchCriteria[action.payload.field] = action.payload.value
    },

    setSearchCriteria(state, action: PayloadAction<StructuredSearchFields>) {
      state.searchCriteria = action.payload
    },

    setSelectedTracks(state, { payload }: PayloadAction<string[]>) {
      const currSelectedTracks = state.searchCriteria.selectedTracks
      if (
        payload.length === currSelectedTracks?.length &&
        payload.every(trackId => currSelectedTracks.includes(trackId))
      )
        return
      state.searchCriteria.selectedTracks = payload
    },
  },
})

export const { setSearchField, setSearchCriteria, setSelectedTracks } =
  structuredSearchSlice.actions

export default persistReducer(
  {
    key: 'structuredSearch',
    whitelist: ['searchCriteria'],
    storage,
    // debug: !PRODUCTION,
  },
  structuredSearchSlice.reducer
)
